// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig :{
    apiKey: "AIzaSyA_VX7AXQPCqFGbblQtR1tt3IzzYb0B_iE",
  authDomain: "quizhack-webapp.firebaseapp.com",
  projectId: "quizhack-webapp",
  storageBucket: "quizhack-webapp.appspot.com",
  messagingSenderId: "145695457161",
  appId: "1:145695457161:web:ed477365c7dfabc9b86b58",
  measurementId: "G-G71DDQR7V2"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
